import { render, staticRenderFns } from "./TestPaper2.vue?vue&type=template&id=6fec384c"
import script from "./TestPaper2.vue?vue&type=script&lang=js"
export * from "./TestPaper2.vue?vue&type=script&lang=js"
import style0 from "./TestPaper2.vue?vue&type=style&index=0&id=6fec384c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports